import { MailEmailsParams } from '../types/api-contracts/mailEmailsParams';
import { MyTaskListGroupBy } from '../types/api-contracts/MyTaskListGroupBy';
import { HandoverStatus } from '../types/domain/handoverItem';

export const handoverQueryKeys = {
  myHandovers: (status: HandoverStatus) => ['handoverList', status] as const,
  receivedHandovers: (status: HandoverStatus) => ['receivedHandoverList', status] as const,
  allMyHandovers: ['handoverList'] as const,
  allReceivedHandovers: ['receivedHandoverList'] as const,
  handoverTasks: (handoverId: string) => ['handoverTasks', handoverId] as const,
  handoverTask: (handoverId: string, taskId: string) => ['handoverTask', handoverId, taskId] as const,
  handoverDetails: (handoverId: string) => ['handoverDetails', handoverId] as const,
  handoverChecklist: (handoverId: string) => ['handoverChecklist', handoverId] as const,
  handoverMyTasksList: (groupBy: MyTaskListGroupBy) => ['handoverMyTasksList', groupBy] as const,
  handoverAllMyTasksList: ['handoverMyTasksList'] as const,
  mailFolders: ['mailFolders'] as const,
  mailEmails: (params: Omit<MailEmailsParams, 'page'>) => ['mailEmails', params] as const,
  handoverCounts: ['handoverCounts'] as const,
};
